/**
 * Text size, chosen by the player and remembered.
 *
 * Scaling the root font size rather than a few labels means every rem in
 * the layout grows with it — type, padding, buttons — so the console
 * reflows instead of overflowing. Browser zoom does the same thing, but a
 * control inside the game is discoverable to the people who need it, which
 * a keyboard shortcut is not.
 */
const KEY = "parroty.textSize";

export const TEXT_SIZES = [1, 1.125, 1.25] as const;

export type TextSize = (typeof TEXT_SIZES)[number];

export function getTextSize(): TextSize {
  if (typeof window === "undefined") return 1;

  const stored = Number(window.localStorage.getItem(KEY));

  return (TEXT_SIZES as readonly number[]).includes(stored) ? (stored as TextSize) : 1;
}

export function applyTextSize(size: TextSize): void {
  if (typeof document === "undefined") return;

  document.documentElement.style.fontSize = `${size * 100}%`;
  window.localStorage.setItem(KEY, String(size));
}

/** The next size in the cycle, wrapping back to normal after the largest. */
export function nextTextSize(size: TextSize): TextSize {
  return TEXT_SIZES[(TEXT_SIZES.indexOf(size) + 1) % TEXT_SIZES.length];
}
